import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/opt/build/repo/src/app/client-providers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/globals.css");
